export default __webpack_public_path__ + "static/media/Previous.7230a5a1.svg";